import React from "react";
import { Link } from "react-router-dom";
import DashboardLayout from "../components/dashboard/DashboardLayout";

const cards = [
  {
    title: "Pages",
    description: "Create and publish CMS pages that power the public site.",
    to: "/dashboard/pages",
  },
  {
    title: "Blog",
    description: "Write and translate news posts for the newsroom and home page.",
    to: "/dashboard/blog",
  },
  {
    title: "Cases",
    description: "Review submitted corruption reports and update case status.",
    to: "/dashboard/cases",
  },
];

const DashboardPage = () => (
  <DashboardLayout
    title="Overview"
    subtitle="Manage multilingual content for the Commission of Integrity website."
  >
    <div className="grid gap-4 md:grid-cols-3">
      {cards.map((card) => (
        <Link
          key={card.title}
          to={card.to}
          className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition hover:border-slate-300 hover:shadow-md"
        >
          <h3 className="text-base font-semibold text-slate-900">{card.title}</h3>
          <p className="mt-2 text-sm leading-relaxed text-slate-500">{card.description}</p>
        </Link>
      ))}
    </div>
  </DashboardLayout>
);

export default DashboardPage;
